"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _scoreHelper = _interopRequireDefault(require("../helpers/score-helper.js"));

var _errors = require("../errors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var portfolio = new _GatewayService["default"]('portfolio-bff');

var filterManualScores = function filterManualScores() {
  var workSummary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!_lodash["default"].isEmpty(_lodash["default"].get(workSummary, 'manualScores'))) {
    var manualScores = [_scoreHelper["default"].getLastUpdatedManualScore(workSummary.manualScores)];
    return Object.assign({}, workSummary, {
      manualScores: manualScores
    });
  }

  return workSummary;
};

var sortWorkSummaries = function sortWorkSummaries() {
  var studentWorkSummaries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cardstackOrGroupingKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var sortedWorkSummaries = {};
  cardstackOrGroupingKeys.forEach(function (key) {
    var workSummary = studentWorkSummaries[key] || {};
    sortedWorkSummaries[key] = filterManualScores(workSummary);
  });
  return sortedWorkSummaries;
};

var fetchWorkSummary = function fetchWorkSummary() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unitKey = arguments.length > 2 ? arguments[2] : undefined;
  var unitRevision = arguments.length > 3 ? arguments[3] : undefined;
  var supressSubmissions = arguments.length > 4 ? arguments[4] : undefined;
  var version = arguments.length > 5 ? arguments[5] : undefined;
  var cardstackGroupingKeys = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  userKeys = Array.isArray(userKeys) ? userKeys : [userKeys];
  cardstackKeys = Array.isArray(cardstackKeys) ? cardstackKeys : [cardstackKeys];

  var requestData = _lodash["default"].flatMap(userKeys, function (userKey) {
    var data = cardstackKeys.map(function (cardstackKey) {
      return {
        userKey: userKey,
        cardstackKey: cardstackKey,
        unitKey: unitKey,
        unitRevision: unitRevision
      };
    });
    cardstackGroupingKeys.forEach(function (cardstackGroupingKey) {
      data.push({
        userKey: userKey,
        cardstackGroupingKey: cardstackGroupingKey,
        unitKey: unitKey,
        unitRevision: unitRevision
      });
    });
    return data;
  });

  var queryParams = supressSubmissions ? '?includeSubmissions=false' : '';
  var url = version && version === 'V2' ? "worksummary".concat(queryParams) : "worksummary/worksummaries".concat(queryParams);
  var cardstackOrGroupingKeys = cardstackKeys.concat(cardstackGroupingKeys);
  return portfolio.post(url, requestData).then(function (workSummaries) {
    return sortWorkSummaryData(workSummaries, cardstackOrGroupingKeys);
  });
};

var sortWorkSummaryData = function sortWorkSummaryData(workSummaries, cardstackOrGroupingKeys) {
  var sortedWorkSummaries = {};

  if (workSummaries) {
    Object.keys(workSummaries).forEach(function (studentId) {
      var studentWorkSummaries = sortWorkSummaries(workSummaries[studentId], cardstackOrGroupingKeys);
      sortedWorkSummaries[studentId] = studentWorkSummaries;
    });
  }

  return sortedWorkSummaries;
};

var fetchUsersWithWork = function fetchUsersWithWork() {
  var userList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unitKey = arguments.length > 2 ? arguments[2] : undefined;
  var unitRevision = arguments.length > 3 ? arguments[3] : undefined;

  if (_lodash["default"].isString(userList)) {
    userList = [userList];
  }

  if (_lodash["default"].isString(cardstackList)) {
    cardstackList = [cardstackList];
  }

  var userCardstacks = _lodash["default"].flatMap(userList, function (userKey) {
    return _lodash["default"].flatMap(cardstackList, function (cardstackKey) {
      return {
        userKey: userKey,
        cardstackKey: cardstackKey,
        unitKey: unitKey,
        unitRevision: unitRevision
      };
    });
  });

  return portfolio.post('worksummary/workexist?filterUsersWithNoWork=true', userCardstacks);
};

var fetchClassSummary = function fetchClassSummary(classKey, unitKey, unitRevision, chapterKey) {
  var lessonKeys = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return portfolio.post('classsummary', {
    classKey: classKey,
    unitKey: unitKey,
    unitRevision: unitRevision,
    chapterKey: chapterKey,
    lessonKeys: lessonKeys
  });
};

var clearWork = function clearWork(userKey) {
  var cardstacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var activities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (_lodash["default"].isEmpty(cardstacks)) {
    return Promise.reject((0, _errors.missingParam)('cardstacks'));
  }

  if (_lodash["default"].isEmpty(activities)) {
    return Promise.reject((0, _errors.missingParam)('activities'));
  }

  return portfolio.post('clean', {
    userKey: userKey,
    cardstacks: cardstacks,
    activities: activities
  });
};

var _default = {
  fetchWorkSummary: fetchWorkSummary,
  fetchUsersWithWork: fetchUsersWithWork,
  fetchClassSummary: fetchClassSummary,
  clearWork: clearWork
};
exports["default"] = _default;